import { useAuthStore, WelfarePlan } from '@tundr/auth';
import { voucherReportsRoutesDictionary } from './voucher-reports-routes.dictionary.ts';
import type { RouteRecordRaw } from 'vue-router';

export const voucherReportsRoutesConfig: RouteRecordRaw = {
  ...voucherReportsRoutesDictionary.voucherReports.root,
  redirect: {
    name: voucherReportsRoutesDictionary.voucherReports.reports.name,
  },
  beforeEnter: () => {
    const authStore = useAuthStore();
    return authStore.currentWelfarePlan === WelfarePlan.COMPLETE;
  },

  children: [
    {
      ...voucherReportsRoutesDictionary.voucherReports.reports,
      component: () =>
        import(
          '@modules/app/reports/pages/VoucherReports/List/VoucherReportListPage.vue'
        ),
    },
  ],
};
